import { ProseMirror } from "@progress/kendo-react-editor";
import { icon } from "./icon";
import { iframe } from "./iframe";
import { editorMarks } from "./marks";
import { nonEditable } from "./nonEditable";

const { Schema } = ProseMirror;

export const updatedSchema = (schema) => {
  const extraNodes = { nonEditable, iframe, icon };
  const paragraph = {
    ...schema.spec.nodes.get("paragraph"),
  };
  paragraph.attrs = paragraph.attrs || {};
  paragraph.attrs["dir"] = {
    default: null,
  };
  // Update schema with paragraph and any additional nodes
  let nodes = schema.spec.nodes.update("paragraph", paragraph);
  // Add any extra nodes if needed (nonEditable, iframe, etc.)
  Object.keys(extraNodes).forEach((nodeName) => {
    nodes = nodes.addToEnd(nodeName, extraNodes[nodeName]);
  });
  return new Schema({ nodes, marks: editorMarks });
};
